import * as UnassignedInstrumentsConstants from "./UnassignedInstrumentsConstants";
import * as CommonConstants from "Common/constants/commonConstants";

// Object.assign is not yet fully supported in all browsers, so we fallback to a polyfill
const assign = Object.assign || require("object.assign");

const initialState = {
  fetchUnassignedDevicesStatus: CommonConstants.STATUS_SUCCESS, // STATUS_SUCCESS -> STATUS_PENDING -> STATUS_FAILURE | STATUS_SUCCESS
  fetchUnassignedDevicesErrMsg: "",
  unassignedDevices: [],
  unassignedDevicesGrpMap: {},
  unassignedDevicesGrpMapStatus: CommonConstants.STATUS_COMPLETED,
  unassignedDevicesGrpMapErrMsg: "",
};

export default function UnassignedInstrumentsReducer(
  state = initialState,
  action
) {
  switch (action.type) {
    case UnassignedInstrumentsConstants.UNASSIGNED_DEVICES_FETCH_REQUEST: {
      const newState = {
        ...state,
        fetchUnassignedDevicesStatus: CommonConstants.STATUS_PENDING,
        fetchUnassignedDevicesErrMsg: "",
        unassignedDevices: [],
      };
      return assign({}, state, newState);
    }
    case UnassignedInstrumentsConstants.UNASSIGNED_DEVICES_FETCH_SUCCESS: {
      const newState = {
        ...state,
        fetchUnassignedDevicesStatus: CommonConstants.STATUS_SUCCESS,
        fetchUnassignedDevicesErrMsg: "",
        unassignedDevices: [...action.payload],
      };
      return assign({}, state, newState);
    }
    case UnassignedInstrumentsConstants.UNASSIGNED_DEVICES_FETCH_ERROR: {
      const newState = {
        ...state,
        fetchUnassignedDevicesStatus: CommonConstants.STATUS_FAILURE,
        fetchUnassignedDevicesErrMsg:
          action.payload?.debugMessage ||
          UnassignedInstrumentsConstants.GENERIC_ERROR_MESSAGE,
        unassignedDevices: [],
      };
      return assign({}, state, newState);
    }

    case UnassignedInstrumentsConstants.CHANGE_UNASSIGNED_DEVICES_GRP_MAP: {
      const newUnassignedDevicesGrpMap = {
        ...state.unassignedDevicesGrpMap,
      };

      if (!action.payload.instGrp) {
        delete newUnassignedDevicesGrpMap[action.payload.instanceId];
      } else {
        newUnassignedDevicesGrpMap[action.payload.instanceId] =
          action.payload.instGrp;
      }

      const newState = {
        ...state,
        unassignedDevicesGrpMap: newUnassignedDevicesGrpMap,
      };

      return assign({}, state, newState);
    }

    case UnassignedInstrumentsConstants.SAVE_UNASSIGNED_DEVICES_GRP_MAP_REQUEST: {
      const newState = {
        ...state,
        unassignedDevicesGrpMapStatus: CommonConstants.STATUS_PENDING,
        unassignedDevicesGrpMapErrMsg: "",
      };

      return assign({}, state, newState);
    }
    case UnassignedInstrumentsConstants.SAVE_UNASSIGNED_DEVICES_GRP_MAP_SUCCESS: {
      const newUnassignedDevices = state.unassignedDevices.filter(
        (el) => !state.unassignedDevicesGrpMap[el.instanceId]
      );

      const newState = {
        ...state,
        unassignedDevices: newUnassignedDevices,
        unassignedDevicesGrpMap: {},
        unassignedDevicesGrpMapStatus: CommonConstants.STATUS_SUCCESS,
        unassignedDevicesGrpMapErrMsg: "",
      };

      return assign({}, state, newState);
    }
    case UnassignedInstrumentsConstants.SAVE_UNASSIGNED_DEVICES_GRP_MAP_ERROR: {
      const newState = {
        ...state,
        unassignedDevicesGrpMapStatus: CommonConstants.STATUS_FAILURE,
        unassignedDevicesGrpMapErrMsg:
          action.payload?.debugMessage ||
          UnassignedInstrumentsConstants.GENERIC_ERROR_MESSAGE,
      };

      return assign({}, state, newState);
    }

    case UnassignedInstrumentsConstants.CANCEL_UNASSIGNED_DEVICES_GRP_MAP: {
      const newState = {
        ...state,
        unassignedDevicesGrpMap: {},
        unassignedDevicesGrpMapStatus: CommonConstants.STATUS_COMPLETED,
        unassignedDevicesGrpMapErrMsg: "",
      };

      return assign({}, state, newState);
    }

    case UnassignedInstrumentsConstants.CLOSE_UNASSIGNED_DEVICES_GRP_MSG_POPUP: {
      const newState = {
        ...state,
        unassignedDevicesGrpMapStatus: CommonConstants.STATUS_COMPLETED,
        unassignedDevicesGrpMapErrMsg: "",
      };

      return assign({}, state, newState);
    }

    case UnassignedInstrumentsConstants.RESET_UNASSIGNED__DEVICES_STATE: {
      return {}, state, { ...initialState };
    }
    default:
      return state;
  }
}
